<template>
    <div class="page-breadcrumb" id="product-services">
        <div class="container-fluid">
            <headerProduct />
            <tablaProduct />
        </div>
    </div>
</template>
<script>
import { mapGetters } from 'vuex';
import headerProduct from './headerProduct.vue';
import tablaProduct from './tablaProduct/index.vue';
export default {
    components: {
        headerProduct,
        tablaProduct
    },
    data() {
        return {
        };
    },
    methods : {
    },
    computed: {
        ...mapGetters("core", {
            getOpenModal: "getOpenModal",
            getActionRefresh: "getActionRefresh",
        }),
    },
    watch: {
    }
};
</script>
<style scoped>
#product-services {
    height: calc(100vh - 42px);
    border-bottom: 0px solid #000;
}
</style>
